import { differenceInDays } from "date-fns";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import { SimpleRangeType } from "@app/scene/home/util/dateUtils";

const getGranularity = (dateRange: DateRange): SimpleRangeType["granularity"] => {
  const diff = Math.abs(differenceInDays(dateRange.startDate, dateRange.endDate));
  if (diff <= 7) {
    return "day";
  } else if (diff <= 90) {
    return "week";
  } else {
    return "month";
  }
};

export default getGranularity;
